// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"436":"0e5c163a705223ab","6400":"a94f72d769840ad5"}[chunkId] + "";
};